/* eslint-disable @typescript-eslint/naming-convention */
import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';

export const StyledToastContainer = styled(ToastContainer)(() => ({
}));
